export default [
  {
    path: '/entrega_llaves/',
    name: 'entregallaves',
    component: () => import('@/views/implementos/llaves_new.vue'),
    meta: {
      pageTitle: 'Entrega de Llaves',
      breadcrumb: [
        {
          text: 'Registros',
        },
        {
          text: 'Entrega de llaves',
          active: true,
        },
      ],
      resource: 'entregallaves',
      action: 'menu',
    },
  },
  {
    path: '/entrega_indumentaria/',
    name: 'entregaindumentaria',
    component: () => import('@/views/implementos/indumentaria_new.vue'),
    meta: {
      pageTitle: 'Entrega de Indumentaria',
      breadcrumb: [
        {
          text: 'Registros',
        },
        {
          text: 'Entrega de Indumentaria',
          active: true,
        },
      ],
      resource: 'entregaindumentaria',
      action: 'menu',
    },
  },
  {
    path: '/busqueda_control_indumentaria/',
    name: 'busq_control_ind',
    component: () => import('@/views/implementos/busq_control_ind.vue'),
    meta: {
      pageTitle: 'Búsqueda/Control Indumentaria',
      breadcrumb: [
        {
          text: 'Registros',
        },
        {
          text: 'Búsqueda/Control Indumentaria',
          active: true,
        },
      ],
      resource: 'busq_control_ind',
      action: 'menu',
    },
  },
  {
    path: '/descuentos/',
    name: 'descuentos',
    component: () => import('@/views/implementos/descuentos.vue'),
    meta: {
      pageTitle: 'Descuentos',
      breadcrumb: [
        {
          text: 'Registros',
        },
        {
          text: 'Descuentos',
          active: true,
        },
      ],
      resource: 'descuentos',
      action: 'menu',
    },
  },
  {
    path: '/deserciones/',
    name: 'deserciones',
    component: () => import('@/views/implementos/deserciones.vue'),
    meta: {
      pageTitle: 'Deserciones',
      breadcrumb: [
        {
          text: 'Registros',
        },
        {
          text: 'Deserciones',
          active: true,
        },
      ],
      resource: 'entregallaves',
      action: 'menu',
    },
  },
]
